// STEPS
export const SET_STEP = 'SET_STEP';
export const SET_STEP_SWITCHING = 'SET_STEP_SWITCHING';

// SELECTION(MATERIALS PAGE)
export const SET_DEFAULT_SELECTION_GROUP = 'SET_DEFAULT_SELECTION_GROUP';
export const TOGGLE_SELECTION_WINDOW = 'TOGGLE_SELECTION_WINDOW';
export const SET_SELECTION_WINDOW_VIEW = 'SET_SELECTION_WINDOW_VIEW';
export const TOGGLE_SELECTION_INFO = 'TOGGLE_SELECTION_INFO';
export const UPDATE_FEATURE_INFO_COUNT = 'UPDATE_FEATURE_INFO_COUNT';
export const CHANGE_SELECTION_INFO_QUANTITY = 'CHANGE_SELECTION_INFO_QUANTITY';
export const TOGGLE_PULSE_FEATURE_INFO_QUANTITY = 'TOGGLE_PULSE_FEATURE_INFO_QUANTITY';
export const CHANGE_MATERIALS_INFO_FEATURE_MODULES = 'CHANGE_MATERIALS_INFO_FEATURE_MODULES';
export const CHANGE_SELECTION_ACTIVE_PART_RELATED_INDEX = 'CHANGE_SELECTION_ACTIVE_PART_RELATED_INDEX';
export const SET_ACTIVE_FEATURE = 'SET_ACTIVE_FEATURE';
export const SET_RELATED_GROUPS = 'SET_RELATED_GROUPS';
export const SET_RELATED_GROUPS_SEARCH = 'SET_RELATED_GROUPS_SEARCH';
export const TOGGLE_SHOW_DESCRIPTION_COVER = 'TOGGLE_SHOW_DESCRIPTION_COVER';
export const TOGGLE_GALLERY_VISIBLE = 'TOGGLE_GALLERY_VISIBLE';
export const SET_GALLERY_ACTIVE_IMAGE_INDEX = 'SET_GALLERY_ACTIVE_IMAGE_INDEX';
export const SET_MATERIALS_PAGE_SUB_STEPS = 'SET_MATERIALS_PAGE_SUB_STEPS';
export const SET_MATERIALS_PAGE_ACTIVE_SUB_STEP = 'SET_MATERIALS_PAGE_ACTIVE_SUB_STEP';
export const TOGGLE_NOT_COMPATIBLE_VIEW = 'TOGGLE_NOT_COMPATIBLE_VIEW';
export const TOGGLE_PRODUCT_NOTE_EDITOR_VISIBLE = 'TOGGLE_PRODUCT_NOTE_EDITOR_VISIBLE';
export const SET_ROW_ITEMS = 'SET_ROW_ITEMS';
export const SET_MATERIALS_PAGE_CANVAS_CLASS = 'SET_MATERIALS_PAGE_CANVAS_CLASS';
export const SET_MATERIALS_PAGE_CANVAS_LOADING = 'SET_MATERIALS_PAGE_CANVAS_LOADING';

// SERVER COMMANDS
export const SET_LAYOUT_DATA_PARTS = 'SET_LAYOUT_DATA_PARTS';
export const SET_JAVASCRIPT_ERRORS = 'SET_JAVASCRIPT_ERRORS';
export const SET_WINDOW_WIDTH = 'SET_WINDOW_WIDTH';
export const SET_WINDOW_HEIGHT = 'SET_WINDOW_HEIGHT';
export const SET_JOB_ID = 'SET_JOB_ID';
export const SET_FABRICATOR_DATA = 'SET_FABRICATOR_DATA';
export const SET_FABRICATOR_TAXES = 'SET_FABRICATOR_TAXES';
export const UPDATE_FABRICATOR_SETTINGS = 'UPDATE_FABRICATOR_SETTINGS';
export const TOGGLE_HIDE_ITEMS_PRICES = 'TOGGLE_HIDE_ITEMS_PRICES';
export const TOGGLE_USE_FABRICATOR_COST_PRICES = 'TOGGLE_USE_FABRICATOR_COST_PRICES';
export const SET_STONE_PRICING = 'SET_STONE_PRICING';
export const ADD_VISUALIZERS_LOADED = 'ADD_VISUALIZERS_LOADED';
export const SET_COOKIE_ACCEPTED = 'SET_COOKIE_ACCEPTED';
export const SHOW_SUCCESS_NOTIFICATION = 'SHOW_SUCCESS_NOTIFICATION';
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_ACTIVE_THEME = 'SET_ACTIVE_THEME';
export const SET_NETWORK_CONNECTION = 'SET_NETWORK_CONNECTION';
export const SET_INITIAL_VISUALIZER_TYPE = 'SET_INITIAL_VISUALIZER_TYPE';

// QUOTINGTOOL CATEGORIES
export const SET_QT_CATEGORIES_REQUESTED = 'SET_QT_CATEGORIES_REQUESTED';
export const SET_QT_CATEGORIES_LOADED = 'SET_QT_CATEGORIES_LOADED';
export const SET_QT_ACTIVE_CATEGORY = 'SET_QT_ACTIVE_CATEGORY';

// BATHROOM VISUALIZER COMMANDS
export const TOGGLE_BATHROOM_VISUALIZER_OPEN = 'TOGGLE_BATHROOM_VISUALIZER_OPEN';
export const SET_BATHROOM_VISUALIZER_VISITED = 'SET_BATHROOM_VISUALIZER_VISITED';
export const SET_BV_CANVAS_ID = 'SET_BV_CANVAS_ID';
export const SET_BV_FEATURES = 'SET_BV_FEATURES';
export const SET_BV_PRESETS = 'SET_BV_PRESETS';
export const SET_ACTIVE_PRESET = 'SET_ACTIVE_PRESET';
export const TOGGLE_SHOW_RESTORE_POPUP = 'TOGGLE_SHOW_RESTORE_POPUP';
export const SET_CANVAS_DIMENSIONS = 'SET_CANVAS_DIMENSIONS';
export const SET_STATIC_CANVAS_IMAGE = 'SET_STATIC_CANVAS_IMAGE';
export const SET_CANVAS_SCALE = 'SET_CANVAS_SCALE';
export const UPDATE_CANVAS_COUNT = 'UPDATE_CANVAS_COUNT';
export const SET_PRESET_WAS_CHANGED_BY_USER = 'SET_PRESET_WAS_CHANGED_BY_USER';
export const SET_FIRST_LOADED_PRESET = 'SET_FIRST_LOADED_PRESET';
export const SET_LOADED_PRESETS = 'SET_LOADED_PRESETS';

// LOADER
export const TOGGLE_LOADER = 'TOGGLE_LOADER';
export const SET_MULTI_LOADER = 'SET_MULTI_LOADER';

// APPLY POPUP
export const TOGGLE_APPLY_POPUP = 'TOGGLE_APPLY_POPUP';
// CONFIRM POPUP
export const TOGGLE_CONFIRM_POPUP = 'TOGGLE_CONFIRM_POPUP';

// USER COMMANDS
export const TOGGLE_USER_POPUP = 'TOGGLE_USER_POPUP';
export const CHANGE_USER_INFO = 'CHANGE_USER_INFO';
export const CHANGE_USER_INFO_ERRORS = 'CHANGE_USER_INFO_ERRORS';
export const SET_EMPLOYEES_LIST = 'SET_EMPLOYEES_LIST';
export const TOGGLE_ADDITIONAL_FIELDS = 'TOGGLE_ADDITIONAL_FIELDS';
export const SET_USER_PHONE_NUMBER_VALIDATED = 'SET_USER_PHONE_NUMBER_VALIDATED';
export const RESTORE_USER_STATE = 'RESTORE_USER_STATE';
export const SET_ALREADY_REGISTERED_USER = 'SET_ALREADY_REGISTERED_USER';
export const SET_LEAD_CAPTURE_CLICK_COUNT = 'SET_LEAD_CAPTURE_CLICK_COUNT';
export const SET_USER_POPUP_CONTENT = 'SET_USER_POPUP_CONTENT';
export const SET_USER_TWO_FA = 'SET_USER_TWO_FA';
export const SET_USER_OPT_IN = 'SET_USER_OPT_IN';

// CART COMMANDS
export const ADD_TO_CART = 'ADD_TO_CART';
export const ADD_DISPLAY_LOGIC_CART_ITEM = 'ADD_DISPLAY_LOGIC_CART_ITEM';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const REMOVE_MANY_FROM_CART = 'REMOVE_MANY_FROM_CART';
export const REMOVE_INSTALLATION_SERVICE_FROM_CART = 'REMOVE_INSTALLATION_SERVICE_FROM_CART';
export const CHANGE_CART_QUANTITY = 'CHANGE_CART_QUANTITY';
export const CHANGE_CART_FEATURE = 'CHANGE_CART_FEATURE';
export const CLICK_QUESTION_NO = 'CLICK_QUESTION_NO';
export const CAME_FROM_PAGE = 'CAME_FROM_PAGE';
export const CLEAR_CART = 'CLEAR_CART';
export const RESTORE_CART = 'RESTORE_CART';
export const ADD_TO_RECENTLY_VIEWED = 'ADD_TO_RECENTLY_VIEWED';
export const SHOW_CHECKOUT_POPUP = 'SHOW_CHECKOUT_POPUP';
export const SUBMIT_PAYMENT = 'SUBMIT_PAYMENT';
export const SUBMIT_PAYMENT_RESPONSE = 'SUBMIT_PAYMENT_RESPONSE';
export const SHOW_ORDER_COMPLETE_POPUP = 'SHOW_ORDER_COMPLETE_POPUP';
export const TOGGLE_SHOW_MOBILE_QUOTES = 'TOGGLE_SHOW_MOBILE_QUOTES';
export const TOGGLE_SHOW_ALL_QUOTES_CART_ITEMS_LIST = 'TOGGLE_SHOW_ALL_QUOTES_CART_ITEMS_LIST';
export const SET_AGREE_EMAIL_CHECKBOX = 'SET_AGREE_EMAIL_CHECKBOX';
export const SET_CART_FOOTER_ACTIVE_BUTTON_INDEX = 'SET_CART_FOOTER_ACTIVE_BUTTON_INDEX';
export const SET_CART_ITEM_EDIT_FEATURE = 'SET_CART_ITEM_EDIT_FEATURE';
export const SET_LOOK_REMOVED_CART_ITEMS = 'SET_LOOK_REMOVED_CART_ITEMS';
export const SET_AMAZON_IMAGE_URL = 'SET_AMAZON_IMAGE_URL';
export const SET_CART_ITEMS_ADDED_TO_PARENT_CART = 'SET_CART_ITEMS_ADDED_TO_PARENT_CART';
export const CHANGE_ALL_CART_ITEMS = 'CHANGE_ALL_CART_ITEMS';
export const SET_SURE_TAX = 'SET_SURE_TAX';
export const SET_SURE_TAX_LOADING = 'SET_SURE_TAX_LOADING';
export const SET_MANUAL_TAX = 'SET_MANUAL_TAX';

export const SET_MARK_UP_LOGIC = 'SET_MARK_UP_LOGIC';
export const SET_DELIVERY_LIST = 'SET_DELIVERY_LIST';
export const SET_ALL_FEATURES_LOADED = 'SET_ALL_FEATURES_LOADED';
export const SET_ALLOW_ROUTING = 'SET_ALLOW_ROUTING';
export const SET_ALLOW_MAIN_LOADING = 'SET_ALLOW_MAIN_LOADING';
export const SET_ACTION_AFTER_VISUALIZER_TYPE_CHANGED = 'SET_ACTION_AFTER_VISUALIZER_TYPE_CHANGED';
export const SET_VISUALIZER_TYPE_CHANGING = 'SET_VISUALIZER_TYPE_CHANGING';
export const SET_JOB_IS_SAVING = 'SET_JOB_IS_SAVING';

// INSTALLATION COMMANDS
export const TOGGLE_INST_OPENED = 'TOGGLE_INST_OPENED';
export const SET_INST_LIST = 'SET_INST_LIST';
export const SET_DEFAULT_INST_LIST = 'SET_DEFAULT_INST_LIST';

// QUOTE STATE
export const SET_STATE_TO_QUOTE = "SET_STATE_TO_QUOTE";

// PRICE WORKSHEET
export const TOGGLE_PRICE_WORKSHEET_OPENED = 'TOGGLE_PRICE_WORKSHEET_OPENED';
export const SET_DISCOUNT_SECTIONS = 'SET_DISCOUNT_SECTIONS';
export const SET_CUSTOM_ADDED_DISCOUNTS = 'SET_CUSTOM_ADDED_DISCOUNTS';
export const SET_FINANCE_PERCENTAGE = 'SET_FINANCE_PERCENTAGE';
export const SET_ALL_FINANCE_OPTIONS_POPUP_VISIBLE = 'SET_ALL_FINANCE_OPTIONS_POPUP_VISIBLE';
export const SET_DISCOUNT_FINANCE_CELLS_VISIBLE = 'SET_DISCOUNT_FINANCE_CELLS_VISIBLE';
export const SET_DISCOUNT_WORKSHEET_COUNT = 'SET_DISCOUNT_WORKSHEET_COUNT';
// export const SET_DISCOUNT_FINANCE_ACTIVE_COMPANY = 'SET_DISCOUNT_FINANCE_ACTIVE_COMPANY';
export const SET_DISCOUNT_FINANCE_PAYMENT_TYPE = 'SET_DISCOUNT_FINANCE_PAYMENT_TYPE';
export const SET_DISCOUNT_FINANCE_ACTIVE_DISCOUNT = 'SET_DISCOUNT_FINANCE_ACTIVE_DISCOUNT';
export const RESTORE_PRICE_WORKSHEET_STATE = 'RESTORE_PRICE_WORKSHEET_STATE';

// MESSAGE BOX COMMANDS
export const CHANGE_MESSAGE_BOX = 'CHANGE_MESSAGE_BOX';
export const SET_UI_POPUP_STATE = 'SET_UI_POPUP_STATE';

// FILTERS
export const SET_SELECTED_FILTERS = 'SET_SELECTED_FILTERS';
export const LOAD_FILTERS = 'LOAD_FILTERS';
export const SET_EXPANDED_FILTERS = 'SET_EXPANDED_FILTERS';
export const SHOW_FILTERS = 'SHOW_FILTERS';
export const SHOW_FILTERS_IF_NOT_VISIBLE = "SHOW_FILTERS_IF_NOT_VISIBLE";
export const SET_FILTER_VISIBLE = 'SET_FILTER_VISIBLE';
export const SET_AVAILABLE_FILTER_VALUES = 'SET_AVAILABLE_FILTER_VALUES';
export const UPDATE_FILTERS_COUNT = 'UPDATE_FILTERS_COUNT';
export const SET_COUNTERTOP_FILTERS_RECEIVED = 'SET_COUNTERTOP_FILTERS_RECEIVED';
export const SET_SEARCH_NAMES_REQUESTED = 'SET_SEARCH_NAMES_REQUESTED';

// DESKTOP NAVIGATION
export const TOGGLE_DESKTOP_NAVIGATION = "TOGGLE_DESKTOP_NAVIGATION";
export const SET_ACTIVE_NAVIGATION_NAMES = "SET_ACTIVE_NAVIGATION_NAMES";

// MOBILE MENU NAV
export const LOAD_MOBILE_NAV = "LOAD_MOBILE_NAV";
export const SHOW_SCHEDULER = "SHOW_SCHEDULER";
export const SCHEDULER_SCHEDULE = "SCHEDULER_SCHEDULE";

// COMMON NAVIGATION
export const SET_MODULE_CONTEXT_MENU_TYPE = "SET_MODULE_CONTEXT_MENU_TYPE";
export const SET_MODULE_CONTEXT_MENU_MODULE = "SET_MODULE_CONTEXT_MENU_MODULE";
export const SET_MODULE_CONTEXT_MENU_MODULE_PART = "SET_MODULE_CONTEXT_MENU_MODULE_PART";
export const SET_MODULE_CONTEXT_MENU_DIRECTION = "SET_MODULE_CONTEXT_MENU_DIRECTION";
export const SET_NAVIGATION_VIEW_TYPE = "SET_NAVIGATION_VIEW_TYPE";
export const SET_CABINETS_APPLY_TO = "SET_CABINETS_APPLY_TO";
export const SET_CABINETS_APPLY_TO_BATHROOM = "SET_CABINETS_APPLY_TO_BATHROOM";
export const SET_COUNTERTOPS_APPLY_TO = "SET_COUNTERTOPS_APPLY_TO";
export const SET_COUNTERTOPS_APPLY_TO_BATHROOM = "SET_COUNTERTOPS_APPLY_TO_BATHROOM";
export const SET_APPLY_TO_COMMON = "SET_APPLY_TO_COMMON";
export const SET_EDGES_APPLY_TO = "SET_EDGES_APPLY_TO";
export const SET_NAVIGATION_LOADING = "SET_NAVIGATION_LOADING";
export const UPDATE_DISABLE_FEATURE_GROUP_RADIO = "UPDATE_DISABLE_FEATURE_GROUP_RADIO";
export const TOGGLE_NAV_ITEM_POSITION_MODAL = "TOGGLE_NAV_ITEM_POSITION_MODAL";
export const SET_USE_FEATURES_LIGHT_REQUEST = "SET_USE_FEATURES_LIGHT_REQUEST";

// CABINET MODULE FILTERS
export const SET_ACTIVE_NAVIGATION_FILTER = "SET_ACTIVE_NAVIGATION_FILTER";
export const SET_ACTIVE_NAVIGATION_FILTER_STEP_INDEX = "SET_ACTIVE_NAVIGATION_FILTER_STEP_INDEX";
export const SET_CABINET_NAVIGATION_FILTER_COMPLETED = "SET_CABINET_NAVIGATION_FILTER_COMPLETED";

//COUNTERTOP WIZARD
export const SET_COUNTERTOP_NAVIGATION_FILTER_COMPLETED = "SET_COUNTERTOP_NAVIGATION_FILTER_COMPLETED";
export const SET_COUNTERTOP_WIZARD = "SET_COUNTERTOP_WIZARD";

//NEW DASHBOARD WIZARD
export const SET_WIZARD_CONFIG = "SET_WIZARD_CONFIG";
export const SET_WIZARD_IS_ACTIVE = "SET_WIZARD_IS_ACTIVE";
export const SET_WIZARD_ACTIVE_FILTER_GROUP_INDEX = "SET_WIZARD_ACTIVE_FILTER_GROUP_INDEX";
export const SET_WIZARD_LIST = "SET_WIZARD_LIST";
export const SET_WIZARD_ACTIVE_ITEM = "SET_WIZARD_ACTIVE_ITEM";
export const SET_WIZARD_SHOW_FEATURE_SECTION = "SET_WIZARD_SHOW_FEATURE_SECTION";
export const SET_WIZARD_ACTIVE_STEP = "SET_WIZARD_ACTIVE_STEP";
export const SET_WIZARD_SELECTED_VALUES = "SET_WIZARD_SELECTED_VALUES";
export const SET_ALL_WIZARD_SELECTED_VALUES = "SET_ALL_WIZARD_SELECTED_VALUES";
export const SET_WIZARD_CONFLICT_POPUP_OPENED = "SET_WIZARD_CONFLICT_POPUP_OPENED";
export const SET_WIZARD_CONFLICT_STEPS = "SET_WIZARD_CONFLICT_STEPS";
export const RESTORE_ALL_WIZARD_SELECTED_VALUES = "RESTORE_ALL_WIZARD_SELECTED_VALUES";
export const SET_WIZARD_MISSING_FEATURES = "SET_WIZARD_MISSING_FEATURES";
export const SET_WIZARD_SQFT_CART_ITEMS = "SET_WIZARD_SQFT_CART_ITEMS";
export const SET_WIZARD_ALLOW_SKIP_DONE_STEPS = "SET_WIZARD_ALLOW_SKIP_DONE_STEPS";

// SQUARE FOOTAGE TOOL
// export const TOGGLE_SQFT = "TOGGLE_SQFT";
export const ENABLE_SQUARE_FOOTAGE = "ENABLE_SQUARE_FOOTAGE";
export const SET_SQUARE_FOOTAGE_GROUP = "SET_SQUARE_FOOTAGE_GROUP";
export const SET_SQFT_VIEW_MODE = "SET_SQFT_VIEW_MODE";
export const LOAD_SQFT = "LOAD_SQFT";
export const UPDATE_SQFT = "UPDATE_SQFT";
export const UPDATE_SQFT_CALCULATIONS = "UPDATE_SQFT_CALCULATIONS";
export const SET_SQFT_SQUARE_FEET = "SET_SQFT_SQUARE_FEET";
export const TOGGLE_CHANGE_LAYOUT_POPUP = "TOGGLE_CHANGE_LAYOUT_POPUP";
export const SET_NEW_LAYOUT_ON_SQFT = "SET_NEW_LAYOUT_ON_SQFT";
export const SET_SQFT_MEASURE_UNIT = "SET_SQFT_MEASURE_UNIT";
export const CHANGE_SQFT_FEATURES_POPUP = "CHANGE_SQFT_FEATURES_POPUP";
export const SQT_SQFT_FROM_FEATURE = "SQT_SQFT_FROM_FEATURE";
export const SET_CABINETS_GLB = "SET_CABINETS_GLB";
export const SET_CABINETS_AR_BLOB_URL = "SET_CABINETS_AR_BLOB_URL";
export const SET_API_ERROR_MESSAGE = "SET_API_ERROR_MESSAGE";
export const SET_SHAPE_IDS_WITH_MISSING_FEATURES = "SET_SHAPE_IDS_WITH_MISSING_FEATURES";
export const SET_CHANGE_SHAPE_FEATURE_MISSING_MESSAGE = "SET_CHANGE_SHAPE_FEATURE_MISSING_MESSAGE";
export const ADD_SHAPE_ID_WITH_MISSING_FEATURES = "ADD_SHAPE_ID_WITH_MISSING_FEATURES";
export const SET_SELECTED_COUNTERTOP = "SET_SELECTED_COUNTERTOP";
export const SET_SELECTED_WALL = "SET_SELECTED_WALL";
export const SET_ABORT_CONTROLLER = "SET_ABORT_CONTROLLER";
export const SET_SQFT_IN_VISUALIZER = "SET_SQFT_IN_VISUALIZER";

// SLAB TOOL
export const SHOW_SLAB_TOOL = "SHOW_SLAB_TOOL";
export const SET_SLAB_TOOL_VISITED = "SET_SLAB_TOOL_VISITED";
export const ADD_ROOM_WITH_VISITED_SLAB_TOOL = "ADD_ROOM_WITH_VISITED_SLAB_TOOL";
export const SET_ACTIVE_SLAB_ID = "SET_ACTIVE_SLAB_ID";
export const SET_ACTIVE_SLAB_URL = "SET_ACTIVE_SLAB_URL";
export const SET_SQFT_SLAB_ACTIVE_STEP = "SET_SQFT_SLAB_ACTIVE_STEP";
export const SET_SQFT_SLAB_SEARCH_TEXT = "SET_SQFT_SLAB_SEARCH_TEXT";
export const SET_SQFT_SLAB_ASPECT_RATIO = "SET_SQFT_SLAB_ASPECT_RATIO";
export const SET_SQFT_SLAB_IMAGE_WIDTH = "SET_SQFT_SLAB_IMAGE_WIDTH";
export const SET_SQFT_SLAB_IMAGE_HEIGHT = "SET_SQFT_SLAB_IMAGE_HEIGHT";
export const SET_SQFT_SLAB_CROPPER_DATA = "SET_SQFT_SLAB_CROPPER_DATA";
export const SET_SQFT_CROPPED_SLAB_IMAGES = "SET_SQFT_CROPPED_SLAB_IMAGES";
export const ADD_SQFT_CROPPED_SLAB_IMAGE = "ADD_SQFT_CROPPED_SLAB_IMAGE";
export const DELETE_CROPPED_SLAB_IMAGE = "DELETE_CROPPED_SLAB_IMAGE";
export const SET_PRICE_PER_AREA = "SET_PRICE_PER_AREA";
export const SET_SLAB_IMAGE_TYPE = "SET_SLAB_IMAGE_TYPE";
export const SET_IS_MEASUREMENT_VISIBLE_IN_SLAB_MODE = "SET_IS_MEASUREMENT_VISIBLE_IN_SLAB_MODE";
export const SET_IS_SIZE_VALIDATION_FAILED = "SET_IS_SIZE_VALIDATION_FAILED";
export const SET_IS_SLAB_PRICING_ENABLED = "SET_IS_SLAB_PRICING_ENABLED";

// MITERED
export const SET_MITERED_SECTIONS = "SET_MITERED_SECTIONS";
export const ADD_MITERED_SECTION = "ADD_MITERED_SECTION";
export const CHANGE_MITERED_SECTION = "CHANGE_MITERED_SECTION";
export const DELETE_MITERED_SECTION = "DELETE_MITERED_SECTION";
export const DELETE_ALL_MITERED_SECTIONS = "DELETE_ALL_MITERED_SECTIONS";

// RESOURCE
export const SET_RESOURCES = "SET_RESOURCES";
export const ADD_RESOURCE = "ADD_RESOURCE";
export const CHANGE_RESOURCE = "CHANGE_RESOURCE";
export const DELETE_RESOURCE = "DELETE_RESOURCE";
export const DELETE_RESOURCE_ATTACHED_TO = "DELETE_RESOURCE_ATTACHED_TO";
export const DELETE_ALL_RESOURCES = "DELETE_ALL_RESOURCES";
export const SET_SELECTED_FEATURE = "SET_SELECTED_FEATURE";
export const SET_SELECTED_PART_IDS = "SET_SELECTED_PART_IDS";
export const SET_SELECTED_HANDLE = "SET_SELECTED_HANDLE";
export const SET_SELECTED_HINGE = "SET_SELECTED_HINGE";
export const SET_RESOURCE_CONTROLLER_COUNTER = "SET_RESOURCE_CONTROLLER_COUNTER";
export const SET_SQFT_CART_ITEMS = "SET_SQFT_CART_ITEMS";

// Canvas Tools Management
export const CANVAS_TOOL_ACTIVATE = 'CANVAS_TOOL_ACTIVATE';
export const CANVAS_TOOL_DEACTIVATE = 'CANVAS_TOOL_DEACTIVATE';
export const CANVAS_TOOL_READY = 'CANVAS_TOOL_READY';

// SQUARE FOOTAGE MENU
export const SET_SQFT_MENU_OPENED = "SET_SQFT_MENU_OPENED";
export const SET_SQFT_MENU_LOCK = "SET_SQFT_MENU_LOCK";
export const SET_SQFT_MENU_ACTIVE_BUTTON = "SET_SQFT_MENU_ACTIVE_BUTTON";
export const SET_SQFT_SYSTEM_MESSAGE = "SET_SQFT_SYSTEM_MESSAGE";
export const SET_SQFT_AR3D_POPUP = "SET_SQFT_AR3D_POPUP";
export const SET_SQFT_POPUP = "SET_SQFT_POPUP";
export const SET_SQFT_CONTEXT_MENU = "SET_SQFT_CONTEXT_MENU";
export const SET_SQFT_CONTEXT_MENU_V2 = "SET_SQFT_CONTEXT_MENU_V2";
export const SET_SQFT_SYSTEM_DELETE_MESSAGE = "SET_SQFT_SYSTEM_DELETE_MESSAGE";
export const SET_SQFT_ACTIVE_SUB_MENU_BUTTON = "SET_SQFT_ACTIVE_SUB_MENU_BUTTON";
export const SET_SQFT_ACTIVE_LEVEL3_BUTTON = "SET_SQFT_ACTIVE_LEVEL3_BUTTON";
export const SET_SQFT_ROOM_LAYOUTS = "SET_SQFT_ROOM_LAYOUTS";
export const SET_SQFT_ACTIVE_ROOM = "SET_SQFT_ACTIVE_ROOM";
export const SET_SQFT_ACTIVE_ROOM_ID = "SET_SQFT_ACTIVE_ROOM_ID";
export const SET_SQFT_ACTIVE_ROOM_TYPE = "SET_SQFT_ACTIVE_ROOM_TYPE";
export const SET_SQFT_ACTIVE_ROOM_INDEX = "SET_SQFT_ACTIVE_ROOM_INDEX";
export const SET_SQFT_ROOM_SWITCHER_VISIBLE= "SET_SQFT_ROOM_SWITCHER_VISIBLE";
export const SET_FREE_DRAW_MODE = "SET_FREE_DRAW_MODE";
export const SET_SQFT_ACTIVE_SHAPE_ID = "SET_SQFT_ACTIVE_SHAPE_ID";
export const SET_FEATURE_PICKER = "SET_FEATURE_PICKER";
export const SET_SELECTED_FEATURE_IN_PICKER = "SET_SELECTED_FEATURE_IN_PICKER";
export const FEATURES_REFRESH_TICK = "FEATURES_REFRESH_TICK";

export const SET_CHANGE_VALUE_POPUPS = "SET_CHANGE_VALUE_POPUPS";
export const ADD_CHANGE_VALUE_POPUP = "ADD_CHANGE_VALUE_POPUP";
export const CHANGE_VALUE_POPUP = "CHANGE_VALUE_POPUP";
export const DELETE_CHANGE_VALUE_POPUP = "DELETE_CHANGE_VALUE_POPUP";

export const SET_VALIDATION_POPUPS = "SET_VALIDATION_POPUPS";
export const ADD_VALIDATION_POPUP = "ADD_VALIDATION_POPUP";
export const VALIDATION_POPUP = "VALIDATION_POPUP";
export const DELETE_VALIDATION_POPUP = "DELETE_VALIDATION_POPUP";

export const SET_WALLS_UP_MODE = "SET_WALLS_UP_MODE";
export const SET_WALLS_LOCK_MODE = "SET_WALLS_LOCK_MODE";
export const SET_IS_ITEXT_EDITING = "SET_IS_ITEXT_EDITING";
export const SET_SLAB_PLACEHOLDER_OVERLAPS_WITH_MULTIPLE_SHAPES = "SET_SLAB_PLACEHOLDER_OVERLAPS_WITH_MULTIPLE_SHAPES";
export const SET_RE_CACHE_MENU_COUNTER = "SET_RE_CACHE_MENU_COUNTER";

// SQUARE FOOTAGE MANUAL CALCULATION
export const TOGGLE_SHOW_MANUAL_CALCULATION = "TOGGLE_SHOW_MANUAL_CALCULATION";
export const SET_SWITCHER_POSITION = "SET_SWITCHER_POSITION";
export const ADD_MANUAL_CALCULATION_ROW = "ADD_MANUAL_CALCULATION_ROW";
export const UPDATE_MANUAL_CALCULATION_ROW = "UPDATE_MANUAL_CALCULATION_ROW";
export const UPDATE_MANUAL_CALCULATION_ROWS = "UPDATE_MANUAL_CALCULATION_ROWS";
export const DELETE_MANUAL_CALCULATION_ROW = "DELETE_MANUAL_CALCULATION_ROW";

// SQUARE FOOTAGE TUTORIAL
export const SET_SQFT_TUTORIAL_STEP = 'SET_SQFT_TUTORIAL_STEP';
export const SET_SQFT_TUTORIAL_SWITCHING = 'SET_SQFT_TUTORIAL_SWITCHING';

// SQUARE FOOTAGE FEATURES GRID
export const SET_ACTIVE_FEATURE_ITEM = 'SET_ACTIVE_FEATURE_ITEM';
export const RESET_ACTIVE_FEATURE_ITEM = 'RESET_ACTIVE_FEATURE_ITEM';

// SQUARE FOOTAGE MODAL
export const MODAL_FIX_OPEN = 'MODAL_FIX_OPEN';
export const MODAL_FIX_CLOSE = 'MODAL_FIX_CLOSE';
export const MODAL_FIX_NEXT_STEP = 'MODAL_FIX_NEXT_STEP';
export const MODAL_FIX_PREV_STEP = 'MODAL_FIX_PREV_STEP';
export const MODAL_FIX_SKIP_STEP = 'MODAL_FIX_SKIP_STEP';
export const MODAL_FIX_TRIGGER_NEXT = 'MODAL_FIX_TRIGGER_NEXT';
export const MODAL_FIX_UPDATE_FEATURE_ID = 'MODAL_FIX_UPDATE_FEATURE_ID';

// SQUARE FOOTAGE TOOLTIP
export const SHOW_SQFT_TOOLTIP = 'SHOW_SQFT_TOOLTIP';
export const HIDE_SQFT_TOOLTIP = 'HIDE_SQFT_TOOLTIP';

// CHECKOUT DOCUSIGN IFRAME
export const SHOW_DOCUSIGN = 'SHOW_DOCUSIGN';
export const SHOW_DEPOSIT = 'SHOW_DEPOSIT';
export const SHOW_CONTRACT_SIGNING = 'SHOW_CONTRACT_SIGNING';
export const SET_AFTER_CONTRACT_SIGN_CALLBACK = 'SET_AFTER_CONTRACT_SIGN_CALLBACK';

// UPLOADS, NOTES & SQFT
export const ADD_PROJECT_DOCUMENT = 'ADD_PROJECT_DOCUMENT';
// export const EDIT_PROJECT_DOCUMENTS = 'EDIT_PROJECT_DOCUMENTS';
export const SET_PROJECT_DOCUMENTS_IDS = 'SET_PROJECT_DOCUMENTS_IDS';

// UPLOADS, NOTES & SQFT
export const SHOW_MATERIALS_TUTORIAL = 'SHOW_MATERIALS_TUTORIAL';
export const SET_MATERIALS_TUTORIAL_STEP = 'SET_MATERIALS_TUTORIAL_STEP';
export const SET_MATERIALS_TUTORIAL_FINISHED = 'SET_MATERIALS_TUTORIAL_FINISHED';
export const SHOW_MATERIALS_AGENT_TUTORIAL = 'SHOW_MATERIALS_AGENT_TUTORIAL';
export const SET_MATERIALS_AGENT_TUTORIAL_FINISHED = 'SET_MATERIALS_AGENT_TUTORIAL_FINISHED';
export const SHOW_VISUALIZER_TUTORIAL = 'SHOW_VISUALIZER_TUTORIAL';
export const SET_VISUALIZER_TUTORIAL_STEP = 'SET_VISUALIZER_TUTORIAL_STEP';
export const SET_VISUALIZER_TUTORIAL_FINISHED = 'SET_VISUALIZER_TUTORIAL_FINISHED';

// CONTRACT SIGNING
export const CONTRACT_SIGNING_SET_STEP = 'CONTRACT_SIGNING_SET_STEP';
export const CONTRACT_SIGNING_POST_SIGNATURE = 'CONTRACT_SIGNING_POST_SIGNATURE';
export const CONTRACT_SIGNING_JOB_DOCUMENT = 'CONTRACT_SIGNING_JOB_DOCUMENT';
export const CONTRACT_SIGNING_SHOW_SIGNATURE_PAD = 'CONTRACT_SIGNING_SHOW_SIGNATURE_PAD';
export const CONTRACT_SIGNING_SET_CONTRACTS_VALUES = 'CONTRACT_SIGNING_SET_CONTRACTS_VALUES';
export const SET_CONTRACT_BLOB = 'SET_CONTRACT_BLOB';
export const CONTRACT_SIGNING_RESTORE_VALUES = 'CONTRACT_SIGNING_RESTORE_VALUES';
export const CONTRACT_SIGNING_SET_CONTRACTS_LIST = 'CONTRACT_SIGNING_SET_CONTRACTS_LIST';
export const SET_CONTRACT_IME_FIELDS_VALUES = 'SET_CONTRACT_IME_FIELDS_VALUES';

// INITIAL FLOW
export const SET_FABRICATOR_SUBSCRIPTIONS = 'SET_FABRICATOR_SUBSCRIPTIONS';
export const SET_INITIAL_FLOW_FINISHED = 'SET_INITIAL_FLOW_FINISHED';
export const SET_INITIAL_FLOW_ADDITIONAL_ROOMS = 'SET_INITIAL_FLOW_ADDITIONAL_ROOMS';
export const SET_INITIAL_FLOW_BUTTON = 'SET_INITIAL_FLOW_BUTTON';
export const SET_INITIAL_FLOW_ROOM = 'SET_INITIAL_FLOW_ROOM';
export const SET_INITIAL_FLOW_VISUALIZER_NOT_AVAILABLE = 'SET_INITIAL_FLOW_VISUALIZER_NOT_AVAILABLE';
export const SET_INITIAL_FLOW_ROOM_LAYOUT = 'SET_INITIAL_FLOW_ROOM_LAYOUT';
export const SET_INITIAL_FLOW_STEP = 'SET_INITIAL_FLOW_STEP';

// UNLOCK CALCULATIONS TUTORIAL
export const SET_SHOW_UNLOCK_CALCULATIONS = 'SET_SHOW_UNLOCK_CALCULATIONS';
export const SET_UNLOCK_CALCULATIONS_STEP = 'SET_UNLOCK_CALCULATIONS_STEP';
export const SHOW_UNLOCK_CALCULATIONS_CART_ITEM = 'SHOW_UNLOCK_CALCULATIONS_CART_ITEM';
export const SHOW_UNLOCK_CALCULATIONS_TOTAL_ITEM = 'SHOW_UNLOCK_CALCULATIONS_TOTAL_ITEM';
export const SHOW_UNLOCK_CALCULATIONS_TUTORIAL = 'SHOW_UNLOCK_CALCULATIONS_TUTORIAL';
export const SET_UNLOCK_CALCULATIONS_TUTORIAL_STEP = 'SET_UNLOCK_CALCULATIONS_TUTORIAL_STEP';
export const SET_UNLOCK_CALCULATIONS_TUTORIAL_FINISHED = 'SET_UNLOCK_CALCULATIONS_TUTORIAL_FINISHED';

// INTRO VIDEO
export const SET_INTRO_VIDEO = 'SET_INTRO_VIDEO';

// QUOTES
export const SET_QUOTES = 'SET_QUOTES';
export const UPDATE_QUOTE = 'UPDATE_QUOTE';
export const SET_ACTIVE_QUOTE_INDEX = 'SET_ACTIVE_QUOTE_INDEX';

// ADVANCED QUOTING
export const TOGGLE_SHOW_ADVANCED_QUOTING = 'TOGGLE_SHOW_ADVANCED_QUOTING';
export const SET_ADVANCED_QUOTING_SEARCH_ITEM = 'SET_ADVANCED_QUOTING_SEARCH_ITEM';

// ADVANCED QUOTING
export const TOGGLE_SHOW_ASSIGN_QUOTE_POPUP = 'TOGGLE_SHOW_ASSIGN_QUOTE_POPUP';
export const SET_ASSIGN_QUOTE_POPUP_SEARCH_TEXT = 'SET_ASSIGN_QUOTE_POPUP_SEARCH_TEXT';
export const SET_ASSIGN_QUOTE_POPUP_EMPLOYEE = 'SET_ASSIGN_QUOTE_POPUP_EMPLOYEE';
export const SET_ASSIGN_QUOTE_POPUP_CUSTOMER = 'SET_ASSIGN_QUOTE_POPUP_CUSTOMER';
export const SET_ASSIGN_QUOTE_POPUP_SUCCESS_TEXT = 'SET_ASSIGN_QUOTE_POPUP_SUCCESS_TEXT';
export const SET_ASSIGN_QUOTE_CLONE_MODE = 'SET_ASSIGN_QUOTE_CLONE_MODE';
export const SET_ASSIGN_QUOTE_OFFLINE_DATA = 'SET_ASSIGN_QUOTE_OFFLINE_DATA';

// RECEIPT
export const SET_RECEIPT_URL = 'SET_RECEIPT_URL';
export const SET_RECEIPT_SIGNATURE = 'SET_RECEIPT_SIGNATURE';
export const SET_RECEIPT_REFERRAL = 'SET_RECEIPT_REFERRAL';

// LOOK ACTIONS
export const SET_LOOK_OPENED = 'SET_LOOK_OPENED';
export const SET_LOOK_EXPANDED = 'SET_LOOK_EXPANDED';
export const SET_LOOK_PARENT_KEY = 'SET_LOOK_PARENT_KEY';
export const SET_LOOK_PARENT_KEYS = 'SET_LOOK_PARENT_KEYS';
export const SET_LOOK_VIEW_TYPE = 'SET_LOOK_VIEW_TYPE';
export const SET_WISHLIST_POPUP_OPENED = 'SET_WISHLIST_POPUP_OPENED';
export const SET_SIDEBAR_MODAL_OPENED = 'SET_SIDEBAR_MODAL_OPENED';
export const SET_LOOK_ACTIVE_FEATURE = 'SET_LOOK_ACTIVE_FEATURE';
export const UPDATE_LOOK_ACTIVE_FEATURE_STOCK_COUNT = 'UPDATE_LOOK_ACTIVE_FEATURE_STOCK_COUNT';
export const SET_LOOK_ACTIVE_CATEGORY = 'SET_LOOK_ACTIVE_CATEGORY';
export const SET_LOOK_MORE_INFO_OPENED = 'SET_LOOK_MORE_INFO_OPENED';
export const SET_LOOK_LAYOUT_OPENED = 'SET_LOOK_LAYOUT_OPENED';
export const SET_LOOK_PAGE_OPENED = 'SET_LOOK_PAGE_OPENED';
export const SET_LOOK_OVERLAY_OPENED = 'SET_LOOK_OVERLAY_OPENED';
export const SET_LOOK_VIEW_CHANGE_OPTIONS = 'SET_LOOK_VIEW_CHANGE_OPTIONS';
export const SET_LOOK_STYLE_POPUP = 'SET_LOOK_STYLE_POPUP';
export const SET_LOOK_REMOVE_POPUP = 'SET_LOOK_REMOVE_POPUP';
export const SET_LOOK_INTRO_STEP = 'SET_LOOK_INTRO_STEP';
export const SET_LOOK_INTRO_HIDDEN = 'SET_LOOK_INTRO_HIDDEN';
export const SET_LOOK_CONTEXT_MENU = 'SET_LOOK_CONTEXT_MENU';
export const SET_LOOK_WALLS_APPLY_TO = 'SET_LOOK_WALLS_APPLY_TO';
export const SET_LOOK_ALL_WALLS_OPENED = 'SET_LOOK_ALL_WALLS_OPENED';
export const SET_LOOK_RETURN_ACTION = 'SET_LOOK_RETURN_ACTION';
export const SET_LOOK_DEMO_POINTS_CLICKED = 'SET_LOOK_DEMO_POINTS_CLICKED';
export const UPDATE_LOOK_NAVIGATION_COUNT = 'UPDATE_LOOK_NAVIGATION_COUNT';
export const UPDATE_LOOK_FEATURE_GROUP_COUNT = 'UPDATE_LOOK_FEATURE_GROUP_COUNT';
export const SET_LOOK_COMPATABILITY_ALERT = 'SET_LOOK_COMPATABILITY_ALERT';
export const SET_LOOK_RESTORE_STATE = 'SET_LOOK_RESTORE_STATE';
export const SET_LOOK_LOCK_TUTORIAL = 'SET_LOOK_LOCK_TUTORIAL';
export const SET_LOOK_ALL_WALLS_TUTORIAL = 'SET_LOOK_ALL_WALLS_TUTORIAL';

// IFRAME ACTIONS
export const SET_IFRAME_INTEGRATION_REQUEST = 'SET_IFRAME_INTEGRATION_REQUEST';
export const SET_IFRAME_INTEGRATION_RESPONSE = 'SET_IFRAME_INTEGRATION_RESPONSE';

// GROHE ACTIONS
// export const SET_GROHE_CATEGORIES_OPENED = 'SET_GROHE_CATEGORIES_OPENED';
export const SET_GROHE_FILTERS_OPENED = 'SET_GROHE_FILTERS_OPENED';
export const SET_GROHE_SIMILAR_FEATURE = 'SET_GROHE_SIMILAR_FEATURE';
export const SET_GROHE_SIMILAR_PRODUCTS_OPENED = 'SET_GROHE_SIMILAR_PRODUCTS_OPENED';
export const SET_GROHE_REQUIRED_BUT_NOT_INCLUDED_FEATURE = 'SET_GROHE_REQUIRED_BUT_NOT_INCLUDED_FEATURE';
export const SET_GROHE_FILTERS_SEARCH_TEXT = 'SET_GROHE_FILTERS_SEARCH_TEXT';
export const SET_GROHE_LAST_OPENED_CATEGORY = 'SET_GROHE_LAST_OPENED_CATEGORY';
export const SET_GROHE_SUB_CATEGORY_OPENED = 'SET_GROHE_SUB_CATEGORY_OPENED';
export const SET_GROHE_SHOW_ADDED_TO_THE_CART_SUCCESS = 'SET_GROHE_SHOW_ADDED_TO_THE_CART_SUCCESS';
export const SET_GROHE_ACTIVE_FEATURE_QUANTITY = 'SET_GROHE_ACTIVE_FEATURE_QUANTITY';
export const SET_GROHE_SHARE_BUTTONS_OPENED = 'SET_GROHE_SHARE_BUTTONS_OPENED';
export const SET_GROHE_SAME_COLOR_ACTIVE_FEATURE = 'SET_GROHE_SAME_COLOR_ACTIVE_FEATURE';
export const SET_GROHE_SAME_COLOR_SECTION_OPENED = 'SET_GROHE_SAME_COLOR_SECTION_OPENED';
export const SET_GROHE_SAME_COLOR_CHECKBOX_APPLIED = 'SET_GROHE_SAME_COLOR_CHECKBOX_APPLIED';
export const SET_GROHE_EXISTING_TEMP_ID = 'SET_GROHE_EXISTING_TEMP_ID';

// GROHE QUOTING TOOL ACTIONS
export const SET_GROHE_WIZARD_NAME = 'SET_GROHE_WIZARD_NAME';
export const SET_GROHE_WIZARD_OPENED = 'SET_GROHE_WIZARD_OPENED';
export const SET_GROHE_WIZARD_STEP = 'SET_GROHE_WIZARD_STEP';

// GROHE SHOPPING CART PAYMENT
export const SET_PAYMENT_INFO = 'SET_PAYMENT_INFO';
export const SET_CARD_INFO = 'SET_CARD_INFO';
export const SET_CARD_ERRORS = 'SET_CARD_ERRORS';
export const SET_SHIPPING_ERRORS = 'SET_SHIPPING_ERRORS';
export const SET_SHIPPING_INFO = 'SET_SHIPPING_INFO';
export const SET_BILLING_INFO = 'SET_BILLING_INFO';
export const RESTORE_PAYMENT_INFO = 'RESTORE_PAYMENT_INFO';

//HISTORY
export const ADD_LAYOUT_HISTORY = 'ADD_LAYOUT_HISTORY';
export const SET_LAYOUT_HISTORY = 'SET_LAYOUT_HISTORY';

//SHOP PAGES
export const SET_SHOP_PAGE_LOADED = 'SET_SHOP_PAGE_LOADED';
export const SET_SHOP_PAGE_OPENED = 'SET_SHOP_PAGE_OPENED';
export const SET_SHOP_LAST_PAGE_VISITED = 'SET_SHOP_LAST_PAGE_VISITED';
export const SET_SHOP_PAGE_LEAVED = 'SET_SHOP_PAGE_LEAVED';
// export const SET_SHOP_ACTIVE_CATEGORY = 'SET_SHOP_ACTIVE_CATEGORY';
// export const SET_SHOP_ACTIVE_FEATURE = 'SET_SHOP_ACTIVE_FEATURE';

// SUPER ADMIN
export const SET_ADMIN_LOGOUT_VISIBLE = "SET_ADMIN_LOGOUT_VISIBLE";
export const SET_ADMIN_LOGIN_POPUP_VISIBLE = "SET_ADMIN_LOGIN_POPUP_VISIBLE";
export const SET_ADMIN_TOOL_SETTINGS_POPUP_VISIBLE = "SET_ADMIN_TOOL_SETTINGS_POPUP_VISIBLE";

// AI
export const SET_AI_LOADING = "SET_AI_LOADING";
export const SET_AI_RESULTS = "SET_AI_RESULTS";
export const SET_AI_USER_FILE_BLOB_URL = "SET_AI_USER_FILE_BLOB_URL";
export const SET_LOOK_AI_IMAGE_OPENED = "SET_LOOK_AI_IMAGE_OPENED";
export const SET_LOOK_AI_RENDER_FINIHSED = "SET_LOOK_AI_RENDER_FINIHSED";
export const SET_LOOK_AI_WAITING_BOX_CLICKED = "SET_LOOK_AI_WAITING_BOX_CLICKED";
export const SET_LOOK_AI_IMAGE_EXPANDED = "SET_LOOK_AI_IMAGE_EXPANDED";
export const SET_LOOK_AI_EXPORT_DATA = "SET_LOOK_AI_EXPORT_DATA";
export const SET_LOOK_AI_IMPORT_DATA = "SET_LOOK_AI_IMPORT_DATA";
export const SET_AI_WAITING_ID = "SET_AI_WAITING_ID";
